// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticlesScreen_root__3UDj_","leftCol":"ArticlesScreen_leftCol__29GIW","description":"ArticlesScreen_description__2yPyu","actionHolder":"ArticlesScreen_actionHolder__WD23a","rightCol":"ArticlesScreen_rightCol__zasjX","slider":"ArticlesScreen_slider__2SHOa","siteImage":"ArticlesScreen_siteImage__t_6pi","siteLink":"ArticlesScreen_siteLink__1oQFL"};
    if(module.hot) {
      // 1586964019498
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  